import { render, staticRenderFns } from "./none-food.vue?vue&type=template&id=f8f83970&scoped=true&"
import script from "./none-food.vue?vue&type=script&lang=js&"
export * from "./none-food.vue?vue&type=script&lang=js&"
import style0 from "./none-food.vue?vue&type=style&index=0&id=f8f83970&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f83970",
  null
  
)

export default component.exports